import { Stack, SxProps, Theme } from "@mui/material";

import ChatMessageSkeleton from "./ChatMessageSkeleton";

export interface ChatHistorySkeletonProps {
  itemCount?: number;
  sx?: SxProps<Theme>;
}

export default function ChatHistorySkeleton({ itemCount = 3, sx }: ChatHistorySkeletonProps) {
  return (
    <Stack spacing={1} sx={{ width: "100%", ...sx }}>
      {Array.from({ length: itemCount }).map((x, i) => (
        <ChatMessageSkeleton key={i} />
      ))}
    </Stack>
  );
}
